<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.766 5.34012C22.766 5.19745 22.7236 5.058 22.6442 4.93948C22.5647 4.82097 22.4519 4.72874 22.3199 4.67452L12.1565 0.499279C11.9813 0.427324 11.7848 0.427324 11.6096 0.499279L1.44614 4.67452C1.31416 4.72873 1.20129 4.82096 1.12185 4.93947C1.04241 5.05799 0.999998 5.19745 1 5.34012V18.5505C0.999998 18.6932 1.04241 18.8326 1.12185 18.9512C1.20129 19.0697 1.31416 19.1619 1.44614 19.2161L11.6096 23.3913C11.7845 23.4633 11.9807 23.4633 12.1556 23.3913C12.1642 23.3884 11.7794 23.5462 22.3199 19.2161C22.4519 19.1619 22.5647 19.0697 22.6442 18.9512C22.7236 18.8326 22.766 18.6932 22.766 18.5505V5.34012ZM11.883 8.79794L8.13817 7.25954L16.2312 3.72909L20.2265 5.37039L11.883 8.79794ZM2.43915 6.47417L5.67008 7.80147V11.5461C5.67008 11.9435 5.99227 12.2657 6.38965 12.2657C6.78704 12.2657 7.10923 11.9435 7.10923 11.5461V8.39269L11.1634 10.0582V21.6522L2.43915 18.0682V6.47417ZM11.883 1.94279L14.3775 2.96755L6.2845 6.49801L3.53956 5.37034L11.883 1.94279ZM12.6026 10.0582L21.3269 6.47417V18.0682L12.6026 21.6522V10.0582Z"
      fill="currentColor"
    />
  </svg>
</template>
